var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
import isNil from 'lodash/isNil';
import { AccessGroup } from '@/security/entities/AccessGroup';
import { Contact } from '@/security/entities/Contact';
import { B2B } from '../../b2b/entity/B2B';
export default class Project {
    id;
    title;
    type;
    exportedAt;
    createdAt;
    weight;
    solutionsCount;
    maxSolutionDiamonds;
    isLabGrown;
    maxYield;
    access;
    dataAccess;
    acl = [];
    accessGroupAcl = [];
    b2b;
    file;
    cbr;
    solutions = [];
    expenses;
    next;
    shortView;
    driveProject = null;
    tasksAvailableAt = null;
    constructor({ id, title, type, exportedAt, createdAt, file, weight, solutionsCount, maxYield, maxSolutionDiamonds, b2b, access, dataAccess, cbr, isLabGrown = false, expenses, next, acl, accessGroupAcl, shortView, 
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _embedded, }) {
        this.id = id;
        this.title = title;
        this.type = type;
        this.exportedAt = exportedAt;
        this.createdAt = createdAt;
        this.file = file;
        this.weight = weight;
        this.solutionsCount = !isNil(solutionsCount) ? solutionsCount : null;
        this.maxYield = !isNil(maxYield) ? maxYield : null;
        this.cbr = cbr;
        this.isLabGrown = isLabGrown;
        this.maxSolutionDiamonds = maxSolutionDiamonds;
        this.b2b = b2b ? new B2B(b2b) : null;
        this.access = access;
        this.dataAccess = dataAccess;
        this.expenses = expenses;
        this.next = next;
        this.acl = (acl ?? []).map((info) => ({ dataAccess: info.dataAccess, assignee: new Contact(info.assignee) }));
        this.accessGroupAcl = (accessGroupAcl ?? []).map((info) => ({
            dataAccess: info.dataAccess,
            accessGroup: new AccessGroup(info.accessGroup),
        }));
        this.shortView = shortView ?? '';
        this.driveProject = _embedded?.driveProject ?? null;
        this.tasksAvailableAt = _embedded?.tasks?.maxAvailableAt ?? null;
    }
    get products() {
        if (!this.solutions) {
            return null;
        }
        if (this.solutions.length === 0) {
            return [];
        }
        return this.solutions.map((s) => s.products).flat();
    }
    setSolutions(solutions) {
        this.solutions = solutions;
    }
    setAccess = (access) => {
        this.access = access;
    };
    getParentId() {
        const projectSummary = this.driveProject;
        if (!projectSummary?.project || projectSummary.suggest) {
            return null;
        }
        return projectSummary.project.id;
    }
}
__decorate([
    observable
], Project.prototype, "solutionsCount", void 0);
__decorate([
    observable
], Project.prototype, "access", void 0);
__decorate([
    observable
], Project.prototype, "dataAccess", void 0);
__decorate([
    observable
], Project.prototype, "acl", void 0);
__decorate([
    observable
], Project.prototype, "solutions", void 0);
__decorate([
    observable
], Project.prototype, "tasksAvailableAt", void 0);
__decorate([
    computed
], Project.prototype, "products", null);
__decorate([
    action
], Project.prototype, "setSolutions", null);
__decorate([
    action
], Project.prototype, "setAccess", void 0);
